import { render } from "./Navbar.vue?vue&type=template&id=b88937ba&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=b88937ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b88937ba"

export default script